/**
 * Creates a custom header for Diatec.
 *
 * @author <mady@oticon.com>
 * @since  30-08-2016
 */

// INHERITED FROM OTICON - START
(function ($) {
  "use strict";

  window.DGS.OnLoad.getInstance().register(function () {
    var $submenu = $("#wrapper .richtext-submenu"),
      $submenuExpander = $(".richtext-submenu .submenu-expander");
    if ($submenu.length) {
      window.DGS.WaitForLoad.getInstance().register($submenu);
    }
    if ($submenu.length) {
      $submenu.css("opacity", 0);
      window.DGS.LoadComplete.getInstance().register($submenu);
    }
    window.DGS.Resizer.getInstance().register(function () {
      var $gridRow = $("#wrapper #content > .row > .grid-12"),
        curValue = parseInt($gridRow.css("padding-top")),
        newValue,
        $languageSelector = $("#wrapper #header .component.language-selector-spot");
      if ($("#wrapper #header .nav-expander").is(":visible")) {
        newValue = parseInt($("#wrapper #header").outerHeight());
      } else {
        newValue = 0;
      }
      $gridRow.css("padding-top", newValue);
      if (newValue !== curValue) {
        window.DGS.Resizer.getInstance().execute();
      }
      if ($("#header").has("search-field-spot") && !$("#header").has("link.order-batteries")) {
        $(".component.link-list.nav").css("margin-right", $languageSelector.outerWidth() + 36 + 40 + "px");
        $languageSelector.css("margin-right", "4rem");
      } else {
        if ($languageSelector.has("li").length !== 0) {
          $(".component.link-list.nav").css("margin-right", $languageSelector.outerWidth() + 36 + 40 + "px");
          $languageSelector.css("margin-right", "5rem");
        } else {
          $(".component.link-list.nav").css("margin-right", $languageSelector.outerWidth() + 36 + "px");
          $languageSelector.css("margin-right", "0px");
        }
      }
      if ($("#header").has("link.order-batteries")) {
        $("#header .link.order-batteries").css("margin-right", $languageSelector.outerWidth() + 36 + 40 + "px");
      }

      // ADD CLASS TO LINK IN LINK LIST IF IT IS BATTERY ORDER.... VERY HARDCODED. Better solution should be made when re-doing the header
      $(".component.link-list.nav li a").each(function () {
        var $this = $(this),
          href = $this.attr("href"),
          isBatteryOrder = href.indexOf("bestil-batterier") != -1;
        if (isBatteryOrder) {
          $this.addClass("order-batteries");
        }
      });
      // HARDCODING end

      var $headerLogo = $("#header a.logo svg"),
        oldHeight = $headerLogo.css("height"),
        newWidth = 140 / 52 * parseInt(oldHeight);
      $headerLogo.css("width", newWidth + "px");

      //Set mobile menu height
      var menuHeight = $(window).height() - $("#header").outerHeight() - parseInt($(".dgs-burger-menu").css("padding-top"));
      $(".dgs-burger-menu").height(menuHeight);
    });
    var languageSpot = $("#header .component.language-selector-spot"),
      $ul = $(".component-content ul", languageSpot),
      tLength = $("li", $ul).length,
      sWidth,
      urlLength = 0,
      tempThis,
      tempURL = "",
      theURL,
      mySpans = "<span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>",
      $logoHeight,
      $header = $("#header"),
      $navLi = $(".link-list.nav li", $header);
    if (tLength > 0) {
      $ul.prepend('<div class="slider"></div>');
      sWidth = 100 / tLength;
      $(".slider", $ul).css({
        width: sWidth + "%"
      });
      theURL = document.location.href.replace("http://", "").replace("https://", "").replace("www.", "");
      $("li", $ul).each(function () {
        tempURL = $("a", $(this)).attr("href").replace("http://", "").replace("https://", "").replace("www.", "");
        if (tempURL.endsWith("/")) {
          tempURL = tempURL.slice(0, -1);
        }
        if (theURL.indexOf(tempURL) === 0 && tempURL.length > urlLength) {
          urlLength = tempURL.length;
          if (tempThis !== undefined) tempThis.removeClass("active");
          tempThis = $(this);
          $(".slider", $ul).addClass("active");
          $(this).addClass("active");
          posCAL($(this));
        }
        $(this).click(function () {
          $(".slider", $ul).addClass("active");
          $("li", $ul).removeClass("active");
          $(this).addClass("active");
          posCAL($(this));
        });
      });
    } else {
      languageSpot.css("display", "none");
    }
    $("#header .component").each(function () {
      $(this).addClass("component-ready animate");
    });
    $(".component.link-list.nav li a").each(function () {
      var href = $(this).attr("href");
      if (window.location.pathname.indexOf(href) === 0) {
        $(".component.link-list.nav li a").removeClass("active"); // reset all so last element matching gets class set. Fixes OD-1312
        $(this).addClass("active"); // add active to this item
      }
    });
    function posCAL(theDiv) {
      var newPos = (theDiv.index() - 1) * sWidth; //Math.floor(position.left)-4;
      if (newPos <= 0) {
        newPos = 2;
      } else {
        newPos += 1;
        if (tLength == theDiv.index()) newPos -= 3;
      }
      $(".slider", $ul).css("left", newPos + "%");
    }
    $(".nav-expander").append(mySpans);
    $(".nav-expander > .component-content").remove();
    $logoHeight = $(".nav-container .component.image .component-content a img").attr("height");
    $(".nav-container").css("height", $logoHeight);
    $(".nav-expander").on("click", function (e) {
      e.preventDefault();
      $(this).toggleClass("nav-expanded");
      $("#header .nav").slideToggle(200);
      if ($(this).hasClass("nav-expanded")) {
        $(".search-field-spot").hide();
      } else {
        $(".search-field-spot").show("slow");
      }
    });
    $(".logo-svg-oticon").each(function () {
      var $a = $(this).find("a"),
        thisHref = $a.attr("href");
      $a.replaceWith('<a class="logo" href="' + thisHref + '"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 140 52" enable-background="new 0 0 140 52" xml:space="preserve"><g class="logo-rect"><rect x="49.8" y="1.5" transform="matrix(0.7071 -0.7071 0.7071 0.7071 12.046 39.2115)" width="7.1" height="7.1"/></g><g class="logo-type"><g class="logo-type-oticon"><path d="M113.9,11.6v24.6h6.1V16.6h5.5c3.7,0,3.9,1.6,4.5,4.8l3.1,14.8h6.4l-3.1-15.7c-1.2-6.4-3.1-8.9-10.3-8.9H113.9L113.9,11.6z M75,31.2c-2.7,0-4.1-0.2-5.3-0.9c-2.3-1.4-3.1-3.3-3.1-6.4c0.1-5.8,2.6-7.3,8.5-7.3H82v-5H73c-3.9,0-7,1-9.3,3.2c-2.2,2-3.6,5.5-3.6,9.2c0,4,1.4,7.1,3.6,9.2c2.3,2.2,5.3,3.1,9.3,3.1H82v-4.9H75L75,31.2z M50.2,16.3v20h6.4V11.6H36.9V2.5h-6.1v9.2h-5.1v4.7h5.1v12.2c0,4.8,2.6,7.8,7.4,7.8h5.5v-4.7h-2.6c-3.1,0-4.3-1.6-4.3-5.1V16.3L50.2,16.3L50.2,16.3z M26.3,23.9c0-7.4-5.3-12.9-13.1-12.9C5.1,11.1,0,16.5,0,23.9C0,30.8,4.7,37,13.1,37C21,37,26.3,31.4,26.3,23.9L26.3,23.9z M6.7,23.9c0-5.4,2.4-7.6,6.5-7.6c4.2,0,6.4,2.6,6.4,7.6c0,4.9-2.6,7.9-6.4,7.9C9,31.8,6.7,29,6.7,23.9L6.7,23.9z M110.3,23.9c0-7.4-5.3-12.9-13.1-12.9C89,11.1,84,16.5,84,23.9C84,30.8,88.6,37,97.1,37C105,37,110.3,31.4,110.3,23.9L110.3,23.9z M90.7,23.9c0-5.4,2.4-7.6,6.5-7.6c4.2,0,6.4,2.6,6.4,7.6c0,4.9-2.6,7.9-6.4,7.9C93,31.8,90.7,29,90.7,23.9L90.7,23.9z"/></g><g class="logo-type-payoff"><g class="logo-type-payoff-people"><path d="M45.4,43h1.7c1.3,0,1.7,0.8,1.7,1.5c0,1-0.7,1.6-1.8,1.6h-1.6V43L45.4,43z M43.9,41.7v10.1h1.5v-4.4h1.5c2.3,0,3.4-1.2,3.4-2.8c0-1.6-1-2.9-3.2-2.9H43.9L43.9,41.7z"/><polygon points="57.7,41.7 51.9,41.7 51.9,51.8 57.8,51.8 57.8,50.5 53.4,50.5 53.4,47.4 57.5,47.4 57.5,46.1 53.4,46.1 53.4,43 57.7,43 57.7,41.7"/><path d="M60.8,46.7c0-2.2,1.7-3.9,3.9-3.9c2.3,0,4,1.6,4,3.9c0,2.2-1.7,3.9-4,3.9C62.4,50.6,60.8,49,60.8,46.7L60.8,46.7z M59.3,46.7c0,2.7,2.1,5.2,5.4,5.2c3.4,0,5.5-2.5,5.5-5.2c0-2.8-2.1-5.2-5.5-5.2C61.4,41.5,59.3,43.9,59.3,46.7L59.3,46.7z"/><path d="M73.5,43h1.7c1.3,0,1.7,0.8,1.7,1.5c0,1-0.7,1.6-1.8,1.6h-1.6V43L73.5,43z M72,41.7v10.1h1.5v-4.4H75c2.3,0,3.4-1.2,3.4-2.8c0-1.6-1-2.9-3.2-2.9H72L72,41.7z"/><polygon points="81.5,41.7 80,41.7 80,51.8 86,51.8 86,50.5 81.5,50.5 81.5,41.7"/><polygon points="94.1,41.7 88.3,41.7 88.3,51.8 94.2,51.8 94.2,50.5 89.8,50.5 89.8,47.4 93.9,47.4 93.9,46.1 89.8,46.1 89.8,43 94.1,43 94.1,41.7"/></g><g class="logo-type-payoff-first"><polygon points="140,41.7 131.5,41.7 131.5,43 135,43 135,51.8 136.5,51.8 136.5,43 140,43 140,41.7"/><path d="M130.1,42.3c-0.7-0.5-1.5-0.7-2.3-0.7c-1.9,0-3.1,1.1-3.1,2.7c0,2.8,4.4,3,4.4,5.1c0,0.6-0.5,1.3-1.6,1.3c-1,0-1.9-0.5-2.7-1.5V51c0.8,0.6,1.7,0.9,2.8,0.9c1.6,0,2.8-1.2,2.8-2.7c0-3.2-4.4-3.2-4.4-5.1c0-0.7,0.7-1.2,1.6-1.2c0.7,0,1.5,0.2,2.4,1.1V42.3L130.1,42.3z"/><path d="M117,42.9h0.9c1.4,0,2,0.6,2,1.5c0,0.8-0.4,1.6-2,1.6H117V42.9L117,42.9z M115.5,41.7v10.1h1.5v-4.4h0.6c0.7,0,1.4,0.2,2.7,2.3l1.3,2.1h1.7c-0.7-1-1-1.3-1.4-2c-0.8-1.3-1.3-2.2-2.3-2.8c1.1-0.4,1.7-1.3,1.7-2.5c0-1.8-1.3-2.8-3.3-2.8H115.5L115.5,41.7z"/><polygon points="111.9,41.7 110.5,41.7 110.5,51.8 111.9,51.8 111.9,41.7"/><polygon points="107.7,41.7 102.3,41.7 102.3,51.8 103.7,51.8 103.7,47.1 107.7,47.1 107.7,45.8 103.7,45.8 103.7,43 107.7,43 107.7,41.7 "/></g></g></g></svg></a>');
    });
    var tl,
      tlWait,
      index = 0;
    tlWait = new TimelineMax({
      repeat: -1
    });
    tlWait.call(function () {
      var $components = $("#wrapper #content .component");
      if ($components.length) {
        $components.each(function () {
          if (!$(this).hasClass("richtext-submenu") && !$(this).hasClass("submenu-point-spot") && $(this).hasClass("animate")) {
            tlWait.pause();
            tlWait.kill();
            tl.play();
          }
        });
      } else {
        tlWait.pause();
        tlWait.kill();
        tl.play();
      }
    }, null, null, "+=0.1");
    tl = new TimelineMax({
      paused: true
    });
    tl.set($navLi, {
      top: -100
    }).call(function () {
      $("a", $navLi).addClass("active");
      $header.addClass("animate");
    }).staggerTo($navLi, 0.4, {
      top: 0,
      ease: Power3.easeOut
    }, 0.1, "+=1");
    if ($(".search-field-spot").length) {
      tl.to($(".search-field-spot"), 0.4, {
        opacity: 1
      });
    }
    if ($submenu.length) {
      tl.to($submenu, 0.4, {
        opacity: 1
      });
    }
    $navLi.each(function () {
      var $this = $(this),
        delay = "+=" + (0.1 * index - 0.3);
      tl.call(function () {
        $("a", $this).removeClass("active");
      }, null, null, delay);
      index++;
    });
    tl.call(function () {
      var $tmpA,
        tmpurl = "";
      $navLi.each(function () {
        var $a = jQuery("a", jQuery(this)),
          href = $a.attr("href"),
          sIndex = href.length,
          section = href.substr(0, sIndex - 1),
          location = window.location.href;
        if (location.indexOf(section) > -1) {
          if (href.length >= tmpurl.length) {
            tmpurl = href;
            $tmpA = $a;
          }
        }
      });
      if ($tmpA && $tmpA.length) $tmpA.addClass("active");
    }, null, null, "+=1");
    if ($submenu.length) {
      tl.call(function () {
        $submenuExpander.addClass("corporate");
      }, null, null);
      tl.call(function () {
        $submenuExpander.removeClass("corporate");
      }, null, null, "+=1.2");
      tl.add(TweenMax.to($submenuExpander, 3, {
        repeat: 3,
        onRepeat: function onRepeat() {
          //$submenuExpander.toggleClass('rotate360');
          //var classes = ['rotate45', 'rotate90', 'rotate135', 'rotate180', 'rotate225', 'rotate270'],
          //var classes = ['rotate90', 'rotate180', 'rotate270', 'rotate360'],
          var classes = ["rotate360", ""],
            i,
            hasClass = false;
          if (!$submenuExpander.closest(".component.richtext-submenu").hasClass("expanded")) {
            for (i = 0; i < classes.length; i++) {
              if (!hasClass && $submenuExpander.hasClass(classes[i])) {
                hasClass = true;
                $submenuExpander.removeClass(classes[i]);
                if (i < classes.length - 1) {
                  $submenuExpander.addClass(classes[i + 1]);
                  break;
                }
              }
            }
            if (!hasClass) {
              $submenuExpander.addClass(classes[0]);
            }
          } else {
            $submenuExpander.removeClass(classes[0]);
            $submenuExpander.removeClass(classes[1]);
            $submenuExpander.removeClass(classes[2]);
            $submenuExpander.removeClass(classes[3]);
            $submenuExpander.removeClass(classes[4]);
            $submenuExpander.removeClass(classes[5]);
          }
        }
      }));
    }
  });
})(jQuery);
// INHERITED FROM OTICON - END

(function ($, DGS) {
  "use strict";

  var megaMenuConfig = {
    hover: true,
    secondLevelNav: false
  };
  DGS.OnLoad.getInstance().register(function () {
    // This could be created with DGS builder
    var $cloned = $(".navigation .component-content > ul").clone();

    // Mega menu creation
    $(".navigation .component-content > ul").megaMenu(megaMenuConfig);
    // Group required functions for the burgerMenu to work
    attachBurgerMenu();

    /**
     * Prepares for the burgerMenu. It handles the external added components (search+phone)
     */
    function attachBurgerMenu() {
      // Lets do thy burger menu
      var backButton = '<a href="#" class="nav-back">Back</a>';
      $(".component.navigation").before(backButton);

      // This could be created with the builder
      var $newPhone = $("#header .rich-text.phone-header").clone(),
        $newSearch = $("#header .search-field-spot").clone(true);

      // Here is where the burgermenu is actually hooked up
      $(".component.navigation .mobile-nav > .mobile-nav-inner").append($cloned.burgerMenu({
        appendElements: [$newPhone, $newSearch]
      }));

      // DISABLE THE AUTOCOMPLETE
      $(".dgs-burger-menu .search-field-spot input").autocomplete({
        disabled: true
      });
      $(".nav-expander").click(function () {
        // This is to override the hide from the .nav-expander (maybe we should not use it?)
        $(".search-field-spot").show();
      });
    }
    DGS.Event.getInstance().trigger(DGS.Events.SELECT_ADDED, $(".component.form select"));
  });
})(jQuery, window.DGS);